<awair-button class="__gray-button"
              (btnClick)="onCancel()">
  <ng-content select="[cancelContents]"></ng-content>
</awair-button>
<awair-button class="__blue-button"
              [hostDisabled]="isDisabled"
              [isLoading]="isLoading"
              (btnClick)="onConfirm()">
  <ng-content select="[confirmContents]"></ng-content>
</awair-button>
